export const SITE_ORIGIN = 'https://calensync.live';
export const OG_IMAGE = `${SITE_ORIGIN}/og.png`;

export const LOCALES = ['en', 'fr', 'es', 'it'] as const;
export type Locale = (typeof LOCALES)[number];

const OG_LOCALES: Record<Locale, string> = {
    en: 'en_US',
    fr: 'fr_FR',
    es: 'es_ES',
    it: 'it_IT',
};

export function isLocale(value: string | null | undefined): value is Locale {
    return value === 'en' || value === 'fr' || value === 'es' || value === 'it';
}

/** Language prefix in the URL, if the path explicitly includes one. */
export function pathLocale(pathname: string): Locale | null {
    const parts = pathname.split('/').filter(Boolean);
    const head = parts[0] === 'dev' ? parts[1] : parts[0];
    return isLocale(head) ? head : null;
}

export function ogLocale(lang: Locale): string {
    return OG_LOCALES[lang];
}

/** Directory URL for a page that exists at the same path in every language. English has no /en prefix. */
export function canonicalUrl(lang: Locale, path: string): string {
    const suffix = path === '/' ? '/' : `${path.replace(/\/$/, '')}/`;
    if (lang === 'en') {
        return `${SITE_ORIGIN}${suffix}`;
    }
    return `${SITE_ORIGIN}/${lang}${suffix}`;
}

export function staticAlternates(path: string): { hrefLang: string; href: string }[] {
    const links: { hrefLang: string; href: string }[] = LOCALES.map((lang) => ({
        hrefLang: lang,
        href: canonicalUrl(lang, path),
    }));
    links.push({ hrefLang: 'x-default', href: canonicalUrl('en', path) });
    return links;
}

export function organizationJsonLd() {
    return {
        '@type': 'Organization',
        name: 'Calensync',
        url: `${SITE_ORIGIN}/`,
        logo: `${SITE_ORIGIN}/logo-small.png`,
        email: 'support@calensync.live',
    };
}

export function homeJsonLd(description: string) {
    return {
        '@context': 'https://schema.org',
        '@graph': [
            organizationJsonLd(),
            {
                '@type': 'WebSite',
                name: 'Calensync',
                url: `${SITE_ORIGIN}/`,
                inLanguage: [...LOCALES],
                publisher: { '@type': 'Organization', name: 'Calensync' },
            },
            {
                '@type': 'SoftwareApplication',
                name: 'Calensync',
                applicationCategory: 'BusinessApplication',
                operatingSystem: 'Web',
                url: `${SITE_ORIGIN}/`,
                description,
            },
        ],
    };
}
